<div class="banner driver-sos-banner">
  <div class="driver-sos-banner__text">
    <div  class="driver-sos-banner__text__header"
          [innerHTML]="'BANNER.DRIVER_SOS.header' | translate | safeHtml">

    </div>
    <div  class="driver-sos-banner__text__description">
      {{ 'BANNER.DRIVER_SOS.description' | translate }}
    </div>
  </div>

  <div class="driver-sos-banner__image">
    <img [src]="imageSrc" alt="">
  </div>

  <div class="driver-sos-banner__button-image">
    <div class="driver-sos-banner__button-image__image">
      <img [src]="logoSos" alt="">
    </div>
    <button (click)="openPopup()" class="btn btn--blue">
      {{ 'BANNER.DRIVER_SOS.buttonText' | translate }}
    </button>
  </div>
</div>
